import $ from "jquery";

let map;
let cityCircle = null;
declare let google: any;

function initMap() {
  const $advLocationMap = $(".js-adviser-location-map");
  const { lat, lng, zoom, mapstyle, radius } = $advLocationMap.data();
  let showpin = false;
  let showradius = false;

  switch (mapstyle) {
    case "pin": {
      showpin = true;
      break;
    }
    case "radius": {
      showradius = true;
      break;
    }
    case "both": {
      showpin = true;
      showradius = true;
      break;
    }
  }

  let loc = { lat: lat, lng: lng };
  map = new google.maps.Map($advLocationMap[0], {
    center: { lat, lng },
    disableDefaultUI: true,
    zoom,
  });

  if (showradius) {
    // Get the CSS variable value for --color-primary
    const rootStyles = getComputedStyle(document.documentElement);
    const colorPrimary = rootStyles.getPropertyValue('--color-primary').trim() || "#0f7b3f";

    cityCircle = new google.maps.Circle({
      center: loc,
      fillColor: colorPrimary,
      fillOpacity: 0.35,
      map: map,
      radius: radius * 1609.34,
      strokeColor: colorPrimary,
      strokeOpacity: 0.8,
      strokeWeight: 2,
    });
  }

  if (showpin) {
    if (
      google.maps.marker &&
      typeof google.maps.marker.AdvancedMarkerElement === "function"
    ) {
      const img = document.createElement('img');
      img.src = "/Content/images/v3/map-pin_primary-green.svg";
      img.className = "adviser-map-pin";
      img.style.width = "var(--adviser-location-map-pin-size, 40px)";
      img.style.height = "var(--adviser-location-map-pin-size, 40px)";

      new google.maps.marker.AdvancedMarkerElement({
        map: map,
        position: loc,
        content: img
      });
    } else {
      // Fallback to classic Marker if AdvancedMarkerElement is unavailable
      new google.maps.Marker({
        map: map,
        position: loc,
        icon: "/Content/images/v3/map-pin_primary-green.svg"
      });
    }
  }
}

function init(): void {
  (window as any)["adviserLocationMapBootstrap"] = () => {
    initMap();
  };
}

export default { init };
